export default class HistoryStorage {
    static isRedirectToConstructor = false;
    static historyArray = [];

    static push(location) {
        if (this.historyArray.length == 0 || this.historyArray[this.historyArray.length - 1] != location) {
            this.historyArray.push(location);
        }
    }
}